import clsx from 'clsx';
import * as React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import { useLocation } from '@reach/router';
import StoryblokLink from '../StoryblokLink';
import { extractLanguage, getStoryblokAlt } from '../../helpers/common';

const getStoryblokDimensions = (url) => {
  const [rawWidth, rawHeight] = url?.split('/')[5]?.split('x') || [];
  const width = Number.parseInt(rawWidth, 10);
  const height = Number.parseInt(rawHeight, 10);

  return {
    width: Number.isNaN(width) ? undefined : width,
    height: Number.isNaN(height) ? undefined : height,
  };
};

export default function TextWithImageSection({ blok }) {
  const location = useLocation();
  const currentLanguage = extractLanguage(location.pathname);
  const isPartnersPage = location.pathname.includes('/partners');
  const parentBlock = blok;
  const styles = clsx(
    `text-with-image-section px-4 lg:px-16 ${
      parentBlock.full_height_desktop ? '' : 'pt-28'
    }`,
  );
  parentBlock.image.src = parentBlock.image.filename;
  const { image } = parentBlock;
  const { width: imageWidth, height: imageHeight } = getStoryblokDimensions(image?.src);
  const sameWidth = blok.image_width === 'lg:w-1/2';
  let textWidthClass = 'lg:w-2/5';

  if (sameWidth) {
    textWidthClass = blok.image_width;
  }

  if (isPartnersPage) {
    textWidthClass = 'lg:w-[46%]';
  }

  return (
    <div
      {...storyblokEditable(blok)}
      className={styles}
      id={blok.internal_page_id || ''}
    >
      <div>
        <div
          className={`flex-col lg:flex-row flex-nowrap items-stretch gap-16 lg:flex ${
            parentBlock.inversedirection ? 'lg:flex-row-reverse' : ''
          }

          ${parentBlock.full_height_desktop ? 'lg:h-[100vh]' : ''}`}
        >
          <div
            className={`w-full ${textWidthClass} flex flex-col items-start justify-center gap-0 lg:gap-0 image-with-text-element`}
          >
            {blok?.blocks.map((block) => (
              <StoryblokComponent
                blok={block}
                key={block._uid}
                extraSettings={{ removePadding: true }}
              />
            ))}

            {parentBlock.buttonlink
              && parentBlock.buttonlink.cached_url.length > 0 && parentBlock.buttontext && (
                <StoryblokLink
                  to={parentBlock.buttonlink?.story?.full_slug || parentBlock.buttonlink.cached_url}
                  title={parentBlock.buttonlink?.link_title || undefined}
                  className="button-general !mt-4"
                  aria-label={
                    currentLanguage === 'en'
                      ? `Read more about ${parentBlock.title || 'this section'}`
                      : `Mehr über ${parentBlock.title || 'diesen Bereich'} erfahren`
                  }
                >
                  {parentBlock.buttontext}
                </StoryblokLink>
            )}
            {parentBlock.image && (
              <div className={`flex items-center lg:hidden justify-center order-2 w-full ${blok.image_width}`}>
                <div className="w-full">
                  <div className="w-full">
                    <div className="">
                      <img
                        src={image.src}
                        alt={getStoryblokAlt(parentBlock.image)}
                        width={imageWidth}
                        height={imageHeight}
                        className={`w-full ${blok.add_border_to_image ? 'border-2 border-solid border-latori-green-dark-dark rounded' : ''}`}
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {parentBlock.image && (
            <div className={`flex items-center hidden lg:flex justify-center order-2 w-full ${blok.image_width}`}>
              <div className="w-full">
                <div className="w-full">
                  <div className="">
                    <img
                      src={image.src}
                      alt={getStoryblokAlt(parentBlock.image)}
                      width={imageWidth}
                      height={imageHeight}
                      className={`w-full ${blok.add_border_to_image ? 'border-2 border-solid border-latori-green-dark-dark rounded' : ''}`}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
